import { Component, ViewChildren, QueryList } from '@angular/core';
import { ModalService, ModalcloseReason, HsgFieldInput } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { ProcessName } from '../constants/process-name.model';
import { AppConfig } from '../../app.config';
import { IAppConfig } from '../../models/app-config.model';

@Component({
  selector: 'app-auth-base',
  template: ''
})
export class AuthBaseComponent {

  public pending: boolean = false;
  public serverError: string = null;
  public gaCategory: string = "Login and Registrarion";
  public appConfig: IAppConfig = null;
  public isShowContactLink:boolean = true;
  @ViewChildren(HsgFieldInput) inputsQuery: QueryList<HsgFieldInput>;

  constructor(
    protected modalService: ModalService,
    protected authUserService: AuthUserService
  ) { this.appConfig = AppConfig.settings }
  
  shouldContactLink(key:string){
    if(this.appConfig){
        let arr = this.appConfig['popupConfig'] as Array<any> || [];
        let elm = arr.find(e => e.popupName == key);
        return elm ? elm.showContactLink : true;
    }
}
  getCurrentProcess(processID: number): string {
    return ProcessName.getProcessName(processID != null ? processID.toString() : "");
  }

  close(needHelp, comeFrom) {
    if (needHelp) {
      let result = null;
      //check whether user has open calls, report 2174 elasticCode
      if (sessionStorage.getItem("checkOpenCalls")) {
        result = { ProcessError: "RequestAlreadyExists", elasticCode: '2174' }
      }
      else {
        sessionStorage.setItem("comeFrom", comeFrom);
        result = { ProcessSuccess: "NeedDetails" }
      }
      this.modalService.close(result);
    }
    else {
      this.modalService.close(ModalcloseReason.buttonX);
    }
  }

  buildFormAccessibility() {
    const form = document.querySelector('[ngForm]');

    if (form) {
      setTimeout(() => {
        this.buildDescribedby(form.querySelectorAll('.h-field'));
      }, 500);

    }
  }

  buildDescribedby(fields) {
    if (fields) {
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i].querySelector('.h-field__element');
        // const error = fields[i].querySelector('[hsgerror]');
        const errors = fields[i].querySelectorAll('[hsgerror]');
        const error = errors[errors.length - 1];


        if (element) {
          if (error) {
            element.setAttribute('aria-describedby', error.id);
          } else {
            element.removeAttribute('aria-describedby');
          }
        }
      }
    }
  }
}
